/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import Button from "../../../shared/components/button/button";
import { Link } from "react-router-dom";
import { PaidProductDetails } from "../../../shared/interfaces/model/tenant.interface";
import { useDispatch } from "react-redux";
import * as actionDeatilTenant from "../../../store/tenant/action";
import { updateTenantObj } from "../../../shared/interfaces/components/detailsTenant.interface";
import { motion } from "framer-motion";
import { ProductMemberDetails2 } from "./ProductMemberDetails2";
import {
  ArrowLeft,
  Building2,
  Calendar,
  ChevronDown,
  ChevronRight,
  Code,
  Edit3,
  MailIcon,
  MapPin,
  Package,
  Phone,
  Save,
  User,
  User2Icon,
  UserCircle,
  X,
} from "lucide-react";
import { Label } from "flowbite-react";
import SuccessModal from "./SuccessModal";
import ErorrModal from "./ErorrModal";
import { useSelector } from "react-redux";
import Loader from "../../../shared/components/loader/Loader";

interface FormData {
  name: string;
  surname: string;
  email: string;
  city: string;
  province: string;
  dateOfBirth: string;
  fiscalCode: string;
  address: string;
  phoneNumber: string;
}

interface TenanUserProps {
  tenant: any;
  disable: boolean;
  productString: string[];
  tenId: string;
  fields: {
    [x: string]: any;
    name: string;
    id: string;
  }[];
  updateTenantRow: (updateTenantParam: updateTenantObj) => void;
  setDisabled: (data: boolean) => void;
}

const TenanUser = ({
  tenant,
  productString,
  tenId,
  fields,
  updateTenantRow,
  disable,
  // setDisabled,
}: TenanUserProps) => {
  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(disable ?? true);
  const [activeTab, setActiveTab] = useState(0);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [emailError, setEmailError] = useState("Generic Error please try again");
  const handleToggle = (index: number) => {
    setActiveTab((prev) => (prev === index ? -1 : index));
  };

  // use selector to get details tenant
  const { detailsTenantIsOk } = useSelector((state: any) => ({
    detailsTenantIsOk: state.tenantsReducer.detailsTenantIsOk,
  }));

  const [formData, setFormData] = useState<FormData>({
    name: "",
    surname: "",
    email: "",
    city: "",
    province: "",
    dateOfBirth: "",
    fiscalCode: "",
    address: "",
    phoneNumber: "",
  });

  useEffect(() => {
    setFormData({
      name: tenant?.userData?.name || "",
      surname: tenant?.userData?.surname || "",
      email: tenant?.userData?.email || "",
      city: tenant?.userData?.city || "",
      province: tenant?.userData?.province || "",
      dateOfBirth: tenant?.userData?.dateOfBirth || "",
      fiscalCode: tenant?.userData?.fiscalCode || "",
      address: tenant?.userData?.address || "",
      phoneNumber: tenant?.userData?.phoneNumber || "",
    });
  }, [tenant]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // get details tenant
  const getDetailTenant = (tenaId: string | undefined) => {
    setFormData({
      name: tenant?.userData?.name,
      surname: tenant?.userData?.surname,
      email: tenant?.userData?.email,
      city: tenant?.userData?.city,
      province: tenant?.userData?.province,
      dateOfBirth: tenant?.userData?.dateOfBirth,
      fiscalCode: tenant?.userData?.fiscalCode,
      address: tenant?.userData?.address,
      phoneNumber: tenant?.userData?.phoneNumber,
    });
    dispatch(actionDeatilTenant.getDetailsTenantRequest(tenaId || ""));
    // status
    // setOrganizationName(tenant.organizationName);
  };

  const fadeIn = {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -30 },
    transition: { duration: 0.3 },
  };

  const slideIn = {
    initial: { x: -30, opacity: 0 },
    animate: { x: 0, opacity: 1 },
    transition: { duration: 0.4, delay: 0.1 },
  };

  const renderInputs = useMemo(() => {
    const fieldsToRender = [
      {
        name: "city",
        label: "City",
        Icon: MapPin,
        id: "city",
        disabled: disabled,
      },
      {
        name: "province",
        label: "Province",
        Icon: MapPin,
        id: "province",
        disabled: disabled,
      },
      {
        name: "dateOfBirth",
        label: "Date of birth",
        Icon: Calendar,
        id: "dateOfBirth",
        disabled: disabled,
      },
      {
        label: "Fiscal code",
        Icon: UserCircle,
        id: "fiscalCode",
        disabled: disabled,
        name: "fiscalCode",
      },
      {
        label: "Address",
        Icon: MapPin,
        id: "address",
        disabled: disabled,
        name: "address",
      },
      {
        label: "Phone number",
        Icon: Phone,
        id: "phoneNumber",
        disabled: disabled,
        name: "phoneNumber",
      },
    ]
    return fieldsToRender.map((field) => (
      <div key={field.id} className="space-y-3">
        <div className="group relative transition-all duration-300 flex items-center gap-2 ">
          <field.Icon className="transform  w-5 h-5 text-slate-400" />
          <label className="text-sm font-medium text-slate-600 dark:text-slate-300">
            {field.label}:
          </label>
        </div>
        <div className="group relative transition-all duration-300">
          <field.Icon
            className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-slate-400 
          group-focus-within:text-sky-500 transition-colors duration-200"
          />
          <input
            className={`w-full pl-10 pr-4 py-3 rounded-xl
        bg-white transition-all duration-200 placeholder-slate-400 text-slate-600 dark:text-slate-200 ${disabled ? "cursor-not-allowed border-slate-300" : "border-green-300 "}`}
            value={formData[field.id as keyof typeof formData]}
            disabled={field.disabled}
            name={field.id}
            id={field.id}
            type="text"
            onChange={handleInputChange}
          />
        </div>
      </div>
    ))
  }, [disabled, formData, handleInputChange]);

  return (
    <motion.div
      className="min-h-screen w-full flex flex-col bg-gradient-to-br from-slate-50/50 to-slate-100/50 dark:from-slate-900 dark:to-slate-800"
      initial="initial"
      animate="animate"
      exit="exit"
      variants={fadeIn}
    >
      <Loader isLoading={!detailsTenantIsOk} />
      <div className="w-full mx-auto px-4 py-8">
        <motion.div
          className="rounded-2xl bg-white/80 dark:bg-slate-800/90 backdrop-blur-sm shadow-xl border border-slate-200/50 dark:border-slate-700/50"
          variants={slideIn}
        >
          <div className="w-full">
            <div
              className="detailsTenant--wrapper col-xs-12 col-lg-12 py-10"
              data-test="detailsTenant-wrapper"
            >
              <p className="text-2xl font-bold mb-10">
                {disabled ? "User Details:" : "Edit User Details:"}
              </p>
              <div className="space-y-8 mb-8">
                <motion.section
                  className="grid grid-cols-1 md:grid-cols-2 gap-6"
                  variants={fadeIn}
                >
                  <div className="space-y-3">
                    <label className="text-sm font-medium text-slate-600 dark:text-slate-300 flex items-center gap-2">
                      <UserCircle className="w-5 h-5" />
                      Name
                    </label>
                    <div className="group relative transition-all duration-300">
                      <User
                        className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-slate-400 
                        group-focus-within:text-sky-500 transition-colors duration-200"
                      />
                      <input
                        className={`w-full pl-10 pr-4 py-3 rounded-xl
                        bg-white transition-all duration-200 placeholder-slate-400 text-slate-600 dark:text-slate-200 ${disabled ? "cursor-not-allowed" : "border-green-300 "}`}
                        data-test="name"
                        name="name"
                        id="signup-name"
                        type="text"
                        value={formData.name}
                        title="Insert field"
                        disabled={disabled}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                  <div className="space-y-3">
                    <label className="text-sm font-medium text-slate-600 dark:text-slate-300 flex items-center gap-2">
                      <UserCircle className="w-5 h-5" />
                      Surname
                    </label>
                    <div className="group relative transition-all duration-300">
                      <User2Icon
                        className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-slate-400 
                        group-focus-within:text-sky-500 transition-colors duration-200"
                      />
                      <input
                        className={`w-full pl-10 pr-4 py-3 rounded-xl
                        bg-white transition-all duration-200 placeholder-slate-400 text-slate-600 dark:text-slate-200 ${disabled ? "cursor-not-allowed" : "border-green-300 "}`}
                        data-test="surname"
                        name="surname"
                        id="surname"
                        type="text"
                        value={formData.surname}
                        title="Insert field"
                        disabled={disabled}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                </motion.section>
              </div>

              {/* Products Section */}
              <motion.section variants={fadeIn} className="space-y-6">
                <div className="flex items-center gap-3">
                  <div className="p-2 rounded-lg bg-sky-100 dark:bg-sky-900/50">
                    <Package className="w-5 h-5 text-sky-600 dark:text-sky-400" />
                  </div>
                  <h2 className="text-lg font-bold text-slate-800 dark:text-white">
                    Products
                  </h2>
                </div>
                <div className="bg-slate-50/50 dark:bg-slate-700/50 backdrop-blur-sm rounded-xl p-6 border border-slate-200/50 dark:border-slate-600/50">
                  <div className="grid gap-4">
                    {tenant?.testProducts?.map(
                      (pro: PaidProductDetails, index: number) => {
                        const isValid =
                          pro.expireDate &&
                          new Date(pro.expireDate) > new Date();
                        if (!isValid) return null;

                        return (
                          <motion.div
                            key={pro.productAppCode}
                            className="space-y-4"
                          >
                            <motion.button
                              className={`w-full flex items-center justify-between p-4 rounded-xl border transition-all duration-200
                            ${activeTab === index
                                  ? "bg-sky-50 dark:bg-sky-900/30 border-sky-500 shadow-sm"
                                  : "border-slate-200 dark:border-slate-600 hover:bg-slate-50 dark:hover:bg-slate-700/50"
                                }`}
                              onClick={() => handleToggle(index)}
                              whileHover={{ scale: 1.01 }}
                              whileTap={{ scale: 0.99 }}
                            >
                              <span className="font-medium text-slate-700 dark:text-slate-200">
                                {pro.productAppName}
                              </span>
                              {activeTab === index ? (
                                <ChevronDown className="w-4 h-4" />
                              ) : (
                                <ChevronRight className="w-4 h-4" />
                              )}
                            </motion.button>

                            {activeTab === index && (
                              <motion.div
                                initial={{ opacity: 0, height: 0 }}
                                animate={{ opacity: 1, height: "auto" }}
                                exit={{ opacity: 0, height: 0 }}
                                transition={{ duration: 0.3 }}
                                className="border rounded-xl border-sky-500 p-6 bg-white/50 dark:bg-slate-800/50 backdrop-blur-sm"
                              >
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                  {fields.map((field) => (
                                    <div key={field.id} className="space-y-2">
                                      <label className="text-sm font-medium text-slate-600 dark:text-slate-300">
                                        {field.name}
                                      </label>
                                      <div className="relative">
                                        <field.Icon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-slate-400" />
                                        <input
                                          className={`w-full pl-10 pr-4 py-3 rounded-xl border border-slate-300 dark:border-slate-700 
                       dark:bg-slate-800 focus:ring-2 focus:ring-sky-500 focus:border-transparent
                      transition-all duration-200 placeholder-slate-400 text-slate-600 dark:text-slate-200 cursor-not-allowed bg-gray-200`}
                                          value={(
                                            pro[
                                            field.id as keyof Omit<
                                              PaidProductDetails,
                                              "invoices"
                                            >
                                            ] ?? ""
                                          ).toString()}
                                          disabled
                                          type="text"
                                          id={field.id}
                                        />
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </motion.div>
                            )}
                          </motion.div>
                        );
                      }
                    )}
                  </div>
                </div>
              </motion.section>

              {tenant && tenant.id && (
                <motion.section variants={fadeIn} className="space-y-6 mt-6">
                  <div className="flex items-center gap-3">
                    <div className="p-2 rounded-lg bg-sky-100 dark:bg-sky-900/50">
                      <User className="w-6 h-6 text-sky-600 dark:text-sky-400" />
                    </div>
                    <h2 className="text-lg font-bold text-slate-800 dark:text-white">
                      Personal Details
                    </h2>
                  </div>

                  <motion.section
                    className="grid grid-cols-1 md:grid-cols-2 gap-6"
                    variants={fadeIn}
                  >
                    <div className="space-y-3">
                      <div className="group relative transition-all duration-300 flex items-center gap-2 ">
                        <MailIcon className="transform  w-5 h-5 text-slate-400" />
                        <label className="text-sm font-medium text-slate-600 dark:text-slate-300">
                          Email:
                        </label>
                      </div>
                      <div className="group relative transition-all duration-300">
                        <div className="group relative transition-all duration-300">
                          <MailIcon
                            className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-slate-400 
                          group-focus-within:text-sky-500 transition-colors duration-200"
                          />
                          <input
                            className={`w-full pl-10 pr-4 py-3 rounded-xl border border-slate-300 dark:border-slate-700 
                      bg-gray-200 dark:bg-slate-800 focus:ring-2 focus:ring-sky-500 focus:border-transparent
                      transition-all duration-200 placeholder-slate-400 text-slate-600 dark:text-slate-200 cursor-not-allowed `}
                            data-test="email"
                            name="email"
                            id="email"
                            type="text"
                            value={formData.email}
                            title="Inserire campo"
                            disabled={false}
                            onChange={() => {
                              return;
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    {renderInputs}
                  </motion.section>
                </motion.section>
              )}

              {/* Action Buttons */}
              <motion.div
                className="flex flex-wrap gap-4 justify-end pt-6"
                variants={fadeIn}
              >
                <Link to="/private/tenantlist">
                  <button
                    className="flex items-center  mr-3 gap-2 px-6 py-3 bg-gradient-to-r from-gray-600 to-gray-700 
                            text-white rounded-xl hover:from-gray-700 hover:to-gray-800 transition-all duration-200
                            shadow-lg shadow-gray-500/20 hover:shadow-gray-500/30"
                  >
                    <ArrowLeft className="w-4 h-4" />
                    Back
                  </button>
                </Link>
                {disabled && (
                  <button
                    onClick={() => setDisabled(false)}
                    className="flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-sky-600 to-sky-700 
                            text-white rounded-xl hover:from-sky-700 hover:to-sky-800 transition-all duration-200
                            shadow-lg shadow-sky-500/20 hover:shadow-sky-500/30"
                  >
                    <Edit3 className="w-4 h-4" />
                    Modify Profile
                  </button>
                )}
                {!disabled && (
                  <>
                    <button
                      onClick={() => {
                        if (tenId) {
                          const upTenant = {
                            id: tenant.id,
                            newName: formData.name,
                            newEmail: formData.email,
                            newProduct: productString,
                            newSurname: formData.surname,
                            newCity: formData.city,
                            newProvince: formData.province,
                            newDateOfBirth: formData.dateOfBirth,
                            newAddress: formData.address,
                            newFiscalCode: formData.fiscalCode,
                            newPhoneNumber: formData.phoneNumber,
                          };
                          updateTenantRow?.(upTenant);
                        }
                        setDisabled(!disabled);
                      }}
                      className="flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-green-600 to-green-700 
                      text-white rounded-xl hover:from-green-700 hover:to-green-800 transition-all duration-200
                      shadow-lg shadow-green-500/20 hover:shadow-green-500/30"
                    >
                      <Save className="w-4 h-4" />
                      Save Edit
                    </button>
                    <button
                      onClick={() => {
                        getDetailTenant(tenId);
                        setDisabled(!disabled);
                      }}
                      className="flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-red-600 to-red-700 
                            text-white rounded-xl hover:from-red-700 hover:to-red-800 transition-all duration-200
                            shadow-lg shadow-red-500/20 hover:shadow-red-500/30"
                    >
                      <X className="w-4 h-4" />
                      Cancel Edit
                    </button>
                  </>
                )}

              </motion.div>
            </div>
          </div>
        </motion.div>
      </div>

      <SuccessModal
        show={showSuccessModal}
        setShow={setShowSuccessModal}
        description="Tenant updated successfully"
      >
        <p>Tenant updated successfully</p>
      </SuccessModal>
      <ErorrModal
        show={showErrorModal}
        setShow={setShowErrorModal}
        emailError={emailError}
      >
        <p>Error updating tenant</p>
      </ErorrModal>
    </motion.div>
  );
};

export default TenanUser;
